import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HospitalityService {

  constructor() { }
  // BehaviorSubject stores and shares data globally
  private marshaDataSource = new BehaviorSubject<any>(null);

  // other components can subscribe to this
  marshaData$ = this.marshaDataSource.asObservable();

  // header or hospitality-unit component will call this
  setMarshaData(data: any) {
    this.marshaDataSource.next(data);
  }

  private headerExpandedSource = new BehaviorSubject<boolean>(true);
  headerExpanded$ = this.headerExpandedSource.asObservable();

  setHeaderExpanded(value: boolean) {
    this.headerExpandedSource.next(value);
  }
}
